module.exports = __webpack_public_path__ + "static/media/left-elements-fisk.542eb324.svg";